import { addOnSchema } from './add-on';
import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const accountProductSchema = z.object({
  active: z.boolean().nullable(),
  addons: z.array(addOnSchema).nullable().optional(),
  applicationId: z.number().nullable(),
  assignedLicenses: z.number(),
  availableLicenses: z.number(),
  expirationDate: coercedDate.nullable(),
  numberOfLicenses: z.number().nullable(),
  productId: z.number().nullable(),
  productName: z.string().nullable(),
  purchaseDate: coercedDate.nullable(),
});

export type AccountProduct = z.infer<typeof accountProductSchema>;
